var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-section",class:_vm.align},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.header)}}),_vm._v(" "),(_vm.teaser.length)?_c('p',[_vm._v(_vm._s(_vm.teaser))]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }